import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CallbackRequestPayload {
  name: string;
  email?: string;
  phone: string;
  preferredDate: string;
  preferredTime: string;
  note?: string;
}

export interface CallbackRequestResult {
  success: boolean;
  message: string;
  id?: string;
}

@Injectable({ providedIn: 'root' })
export class CallbackService {
  private readonly http = inject(HttpClient);

  create(payload: CallbackRequestPayload): Observable<CallbackRequestResult> {
    return this.http.post<CallbackRequestResult>(`${environment.apiUrl}/CallbackRequests`, payload);
  }
}
